import React from 'react' 
import { Link } from 'gatsby'
import { FiChevronRight } from 'react-icons/fi'

import style from './RelatedGuides.module.scss'

const RelatedGuides = ({
  guides,
  microcopy
}) => (
  <>
    { guides?.[0] && process.env.GATSBY_FEATURE_GUIDES === 'true' && (
      <div className={ style.related_links }>
        <h1>
          { microcopy.text('guides.titles.related_guides') }
        </h1>
        <ul>
          { guides.map(guide => (
            <li key={ guide.id } className={ style.guide }>
              <Link to={ guide.path }>
                <span className={style.category}>{ guide.category.title }</span>
                <FiChevronRight />
                { guide.title }
              </Link>
            </li>
          ))}
        </ul>
      </div>
    )}
  </>
)

export default RelatedGuides

